import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    width: "50%",
    paddingBottom: "20px",
    margin: "0 auto"
  },
  inputLabel: {
    fontSize: "1vw"
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

export default function SimpleSelect(props) {
  const classes = useStyles();

  const [value, setValue] = React.useState(props.initialType);
  
  function handleChange(event) {
    setValue(event.target.value);
    props.onHandleChange(event.target.value);
  }

  return (
    <FormControl className={classes.formControl}>
      <InputLabel className={classes.inputLabel} htmlFor="alt-options">
        {props.label}
      </InputLabel>
      <Select value={value} onChange={handleChange}>
        {props.types.map(type => (
          <MenuItem key={type.id} value={type.type}>
            {type.type}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
